import { SearchSectionForm } from "src/components/common/form/search/SearchSectionForm";
import { SearchDropDownForm } from "src/components/common/form/search/SearchDropDownForm";
import { SysCodeDto } from "src/dtos/code/sysCodeDto";
import { useSYS3060_R01Store } from "src/containers/mes/SYS/SYS3060_R01/Store_SYS3060_R01";
import { useCommonCodeStore } from "src/store/useCommonCodeStore";

interface Props {
}

export const SearchSection_SYS3060_R01 = ({
}: Props) => {
	const { 
		SYS3060_R01Filter, 
		setSYS3060_R01Filter,
	} = useSYS3060_R01Store();

	const { yesNoList, systemList } = useCommonCodeStore();

	return (
		<SearchSectionForm>
			{/* filter : {JSON.stringify(SYS3060_R01Filter)} <br /> */}
			<SearchDropDownForm<SysCodeDto>
				label="업무시스템"
				value={SYS3060_R01Filter.menuCd || 'all'}
				optionList={systemList}
				onChangeValue={v => setSYS3060_R01Filter({ menuCd: v === 'all' ? '' : v })}
				wrapperOption={{
					titleStyle: "h-[24px] flex items-center truncate shrink-0 w-[60px] min	-w-[60px]",
					selectStyle: "w-[100px] min-w-[90px] border border-gray-300 px-[6px] h-[24px] rounded-[6px]",
				}}
			/>
			<SearchDropDownForm<SysCodeDto>
				label="사용여부"
				value={SYS3060_R01Filter.useYn || 'all'}
				optionList={yesNoList}
				onChangeValue={v => setSYS3060_R01Filter({ useYn: v === 'all' ? '' : v })}
			/>
		</SearchSectionForm>
	);
}; 